<template>
  <v-container id="fixed-delivery-detail">
    <div v-if="deliveryInfo">
      <v-row>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">예약자</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{customerInfo.name}}
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">예약 날짜</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{$func.dateTimeToString(deliveryInfo.created)}}
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">연락처</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{customerInfo.mobileNo}}
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">비상 연락처</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <div v-for="item in isExistFamilyInfo">
            <span class="mr-3">{{item.phone}}</span>
            <span>{{item.relation}}</span>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">회원 유형</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{showCustomerType}}
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">비고</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{getEtcInfo(customerInfo)}}
        </v-col>
      </v-row>
      <v-divider></v-divider>

      <v-row>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">예상 픽업 시간</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{$func.dateTimeToString(deliveryInfo.expectedStartTime)}}
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">예상 배송 완료 시간</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{$func.dateTimeToString(deliveryInfo.expectedEndTime)}}
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">예상 주행 거리</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{deliveryInfo.expectedTotalDistance ? Number(deliveryInfo.expectedTotalDistance/1000).toFixed(3) : '0' }} km
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">실제 배송 완료 시간</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{deliveryInfo.realEndTime ? deliveryInfo.realEndTime : '-'}}
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">배송 물품</span>
        </v-col>
        <v-col cols="12" sm="6" md="10">
          {{parcelList}}
        </v-col>
      </v-row>
      <v-divider></v-divider>

      <v-row>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">시내/시외</span>
        </v-col>
        <v-col cols="12" sm="6" md="10">
          {{ suburbanString }}
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">출발지</span>
        </v-col>
        <v-col cols="12" sm="6" md="10">
          {{deliveryInfo.expectedDeparture}}
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span class="font-weight-black">도착지</span>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          {{deliveryInfo.expectedDestination}}
        </v-col>
      </v-row>
    </div>
  </v-container>

</template>

<script>
export default {
  name: "FixedDeliveryDetail",
  props:{
    deliveryInfo:{
      type: Object,
      default: null,
    },
    customerInfo:{
      type: Object,
      default: null,
    }
  },
  computed:{
    suburbanString() {
      // TODO: deliveryRange 마이그레이션 후 분기 삭제
      const deliveryData = this.deliveryInfo;
      if (deliveryData.deliveryFareType === null) {
        const suburbanArr = this.deliveryInfo.deliveryRange.configName.split('|');
        return (suburbanArr[1] === '시내') ? '시내' : `시외 (${suburbanArr[0]} - ${suburbanArr[1]}(${suburbanArr[2]}))`;
      } else {
        // 마이그레이션 후 남겨 놓을 부분
        const fareType = deliveryData.deliveryFareType;
        if (!fareType.startsWith('suburban')) {
          return '시내';
        } else {
          return (fareType !== 'suburban_fr_delivery_area') ? '시외' : `시외 (${deliveryData.deliveryFareDetail})`;
        }
      }
    },
    isExistFamilyInfo() {
      if(this.customerInfo) {
        return  JSON.parse(this.customerInfo.familyContactList);
      }
      return [];
    },
    showCustomerType() {
      const customerType = this.customerInfo.customerType;
      if(customerType === null) {
        return '일반';
      } else if(customerType.configValue === 'ct_normal' || customerType.configValue === 'ct_guardian') {
        return customerType.configName;
      } else {
        return '교통약자 ('+ customerType.configName + ')';
      }
    },
    showMobilityWeekInfo() {
      const isMobilityWeek = this.customerInfo.mobilityWeakInfo;
      if(isMobilityWeek) {
        return JSON.parse(this.customerInfo.mobilityWeakInfo.handicapInfo);
      }
      return;

    },
    showWheelChairInfo() {
      const isMobilityWeek = this.customerInfo.mobilityWeakInfo;
      if(isMobilityWeek) {
        return isMobilityWeek.wheelchair;
      }
      return;

    },
    parcelList() {
      if(!this.deliveryInfo.parcelType) return;
      const list = JSON.parse(this.deliveryInfo.parcelType).map(x => x.configName).join(',');
      const comment = this.deliveryInfo.parcelDescription ? this.deliveryInfo.parcelDescription : '';
      return comment ? list + ' (' + comment + ')' : list;
    },
  },
  methods: {
    getEtcInfo(customerInfo) {
      if(!customerInfo) {
        return "";
      }

      //FIXME: 추후에 cutomer dto로 변경하세요.....
      const {customerType, expectedDeliveryDate, mobilityWeakInfo} = customerInfo;

      if (customerType && customerType.configValue === 'ct_pregnant' && expectedDeliveryDate) {
        return expectedDeliveryDate + " 출산예정";

      } else if (customerType && customerType.configValue === 'ct_mobility_week' && mobilityWeakInfo) {
        const {handicapInfo, wheelchair} = mobilityWeakInfo;
        let displayText = "";

        const handicapArr = JSON.parse(handicapInfo);
        displayText = handicapArr.map(handicap => {
          const {type, degree} = handicap;
          return type+'('+degree+')';
        }).join();

        if (wheelchair !== '없음') {
          displayText += '/' + wheelchair + "휠체어";
        }

        return displayText;
      }

      return "";
    },
  }

}
</script>

<style scoped>

</style>
